import { Box, Button, Container, Grid, Typography } from "@mui/material";
import ContactUs from "./ContactUs";

export default function Contact() {

    return (
        <>
            <Box py={6} sx={{ background: '#FFFFFF' }}>
                <Container sx={{ textAlign: 'center' }}>
                    <Typography color='primary.main' fontWeight={600} textAlign='center'>
                        Get in Touch
                    </Typography>
                    <Typography variant="h2" mb={4}>
                        Contact Us
                    </Typography>
                </Container>
                <ContactUs/>
            </Box>
            <Box py={6} sx={{ background: 'linear-gradient(#E7F0FF, #E8F1FF)'  }}>
                <Container sx={{ textAlign: 'center' }}>
                    <Typography color='primary.main' fontWeight={600} textAlign='center'>
                        Reach Us
                    </Typography>
                    <Typography variant="h2" mb={4}>
                        Our Locations
                    </Typography>
                    <div className="flex flex-wrap justify-center gap-5">
                        <Typography color='primary.main' fontWeight={600} textAlign='center'>
                            VEM Plus Urgent Care – Head Office
                        </Typography>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.4461441986396!2d77.0657437760104!3d28.405791894340236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d23ca4146e16d%3A0x5ed09a3aa35e2dfc!2sVem%20Plus%20Urgentcare%20%26%20Emergency%20clinic!5e0!3m2!1sen!2sin!4v1741243122966!5m2!1sen!2sin" width="100%"
                                height="350"
                                allowfullscreen=""
                                loading="lazy"></iframe>
                        <Typography color='primary.main' fontWeight={600} textAlign='center'>
                            VEM Plus Urgent Care – Branch Office
                        </Typography>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1754.0601690635222!2d76.9675739!3d28.4457886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d17b9c3208d53%3A0xcbecb6fea86980ff!2sThe%20Millennia%201%20Sector%2037D%20Gurugram!5e0!3m2!1sen!2sin!4v1741241777004!5m2!1sen!2sin"  width="100%"
                                height="350"
                                allowfullscreen=""
                                loading="lazy"></iframe>
                    </div>
                </Container>


            </Box>
        </>



    )
}
